import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const MenuContent = styled.ul`
    background-color: ${MIGRATED_COLORS.literalFff};
    border-radius: 3px;
    border: 1px solid ${MIGRATED_COLORS.literalC4ccd3};
    box-shadow: 0 6px 12px ${MIGRATED_COLORS.literalRgba0000175};
    list-style: none;
    margin: ${({ distanceFromContainer }) => distanceFromContainer}px 0 0;
    min-width: 160px;
    overflow: hidden;
    padding: 0;
    ${({ theme }) => theme.media.down('md')`
        min-width: 120px;
    `};
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('MenuContent.styles')};
`;

MenuContent.propTypes = {
    /**
     * A dynamic margin for the MenuContent
     */
    distanceFromContainer: PropTypes.number,
};

MenuContent.defaultProps = {
    distanceFromContainer: 0,
};

export default MenuContent;
